var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoButton(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_18932",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 18932",
    transform: "translate(-1765 -6485)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_17332",
    "data-name": "\\u9577\\u65B9\\u5F62 17332",
    width: 66,
    height: 66,
    transform: "translate(1765 6485)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_18905",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 18905",
    transform: "translate(-4 -2.73)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_18904",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 18904",
    transform: "translate(1771 6489.771)",
    opacity: 0.907
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_9454",
    "data-name": "\\u30D1\\u30B9 9454",
    d: "M67.787,47.482c18.9-.124,31.307,8.893,31.307,30.753s-10.674,31.607-31.1,31.607-31.341-9.748-31.341-31.607S48.886,47.605,67.787,47.482Z",
    transform: "translate(-36.653 -47.48)",
    fill: "#bebeff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_29188",
    "data-name": "\\u30D1\\u30B9 29188",
    d: "M2.307,0C.232,0,0,2.021,0,2.89A12.141,12.141,0,0,0,4.4,11.4a16.771,16.771,0,0,0,11.217,4.256A16.753,16.753,0,0,0,26.83,11.4,12.054,12.054,0,0,0,31.222,2.89c0-.867-.218-2.89-2.3-2.89a3.152,3.152,0,0,0-.548.053A59.429,59.429,0,0,1,15.613,1.472,60.366,60.366,0,0,1,2.848.053,2.942,2.942,0,0,0,2.3.009Z",
    transform: "translate(1786.464 6526.288)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoButton);
export default __webpack_public_path__ + "static/media/logoButton.3307bf4be4b55fe095ff94f538a0877d.svg";
export { ForwardRef as ReactComponent };